module.exports = __webpack_public_path__ + "static/videoImageMobile-3243947752cd980797857281b281ff8b.png";